export default __webpack_public_path__ + "static/coconutrasgulla-bdf163fed229c0d4965182a33d889126.png";